import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Building2, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AMDEN_LOGO } from "@/components/SeqLogo";

export default function PlatformLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-slate-950 text-slate-100">
      <aside className="w-64 shrink-0 border-r border-white/10 flex flex-col">
        <div className="px-5 py-5 border-b border-white/10 flex items-center gap-3">
          <img src={AMDEN_LOGO} alt="Amden Control" className="h-10 w-10 rounded-full ring-1 ring-white/10" />
          <div>
            <div className="font-semibold tracking-tight">Amden Control</div>
            <div className="text-[10px] text-slate-400 uppercase tracking-[0.15em]">Platform Console</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <NavLink to="/platform/accounts" data-testid="nav-accounts"
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-seq-green/20 text-white border-l-2 border-seq-green pl-[10px]" : "text-slate-400 hover:bg-white/5 hover:text-white"}`}>
            <Building2 size={17} /> Accounts
          </NavLink>
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="flex items-center gap-2 px-2 py-2 text-xs">
            <ShieldCheck size={15} className="text-seq-green shrink-0" />
            <div className="min-w-0">
              <div className="text-slate-200 truncate">{user?.name}</div>
              <div className="text-slate-500 truncate">{user?.email}</div>
            </div>
          </div>
          <button onClick={logout} data-testid="platform-logout"
            className="mt-1 w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-slate-300 hover:bg-white/5 transition-colors">
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-6 sm:p-10 max-w-6xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
